import { BrowserRouter as Router, Switch } from "react-router-dom";
import {useDispatch} from 'react-redux';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {refreshConnection} from './actions/signalr.action';
import React, { useEffect, useState } from 'react';
import SignIn from "./views/Signin";
// import SignUp from "./views/Signup";
import Layout from './views/layout';
// import moment from 'moment'
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";


//Views
// import Proyects from "./views/Proyects";
import Home from "./views/Home";
import Proyects from "./views/Proyects";
import PcGeneral from "./views/PcGeneral";
// import Test from "./views/Test";

//Routes
import {
	PrivateRoute,
	Authform
  } from "./routes/PrivateRoutes";
import Business from "./views/Business";
import IndicatorsWebView from "./views/IndicatorsWebView";
import CashFlowPC from "./views/cash-flow/pc";
import CashFlowPD from "./views/cash-flow/pd";
import CashFlowItem from "./views/cash-flow/item";
import CategoryDocumentType from "./views/cash-flow/categoryDocumentType";
import Resources from "./views/cash-flow/resources";
import BillsPage from "./views/logistic-indicators/bills";
import AccountsPayable from "./views/iframe/AccountsPayable";
import LiPcView from "./views/logistic-indicators/pc";
import GeneralPC from "./views/logistic-indicators/general-pc";
import BillsToPay from "./views/iframe/BillsToPay";
import AccountsReceivable from "./views/iframe/AccountsReceivable";
import AttendancesResume from "./views/iframe/AttendancesResume";

// moment.locale("es");
function App() {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true)	

	useEffect(() => {
		dispatch(refreshConnection(localStorage.getItem('auth-token')));
		setTimeout(() => {
		  setLoading(false);
		}, 1000);
		// eslint-disable-next-line
	  }, []);

  if(loading) return 'Cargando...';
  
  return (
	<MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale} >
    <Router>
      <Switch>
		    {/* <Route path="/test" component={Test} /> */}
        <Authform exact path="/" component={SignIn} />
        {/* <Route path="/signup" component={SignUp} /> */}

        <Layout>
			<PrivateRoute path="/home" component={Home} />
			<PrivateRoute path="/projects" component={Proyects} exact={false} />
			{/* <PrivateRoute path="/projects/*" component={Proyects} /> */}

			<PrivateRoute path="/pc-general" component={PcGeneral} exact={false} />
			{/* <PrivateRoute path="/pc-general/*" component={PcGeneral} /> */}
			{/* 
			<PrivateRoute path="/pc-general/:codPcg" component={PcGeneral} />
			<PrivateRoute path="/pc-general/:codPcg/proyecto/:codProject" component={PcGeneral} />
			<PrivateRoute path="/pc-general/:codPcg/proyecto/:codProject/recursos/:codMeans" component={PcGeneral} /> */}

			<PrivateRoute path="/business" component={Business} exact={false}/>
			{/* <PrivateRoute path="/business/:codUnd" component={Business} /> */}
			{/* <Route path="/proyects/:codProject" component={Proyects} /> */}

			<PrivateRoute path="/gastos" component={IndicatorsWebView} exact={true}/>
			<PrivateRoute path="/gastos-pc" component={IndicatorsWebView} exact={true}/>
			<PrivateRoute path="/gastos-pc-general" component={IndicatorsWebView} exact={true}/>

			{/* flujo de caja */}
			<PrivateRoute path="/flujo-de-caja-pc" component={CashFlowPC} exact={true}/>
			<PrivateRoute path="/flujo-de-caja-proyecto-y-dimensiones" component={CashFlowPD} exact={true}/>
			<PrivateRoute path="/flujo-de-caja-rubros" component={CashFlowItem} exact={true}/>
			<PrivateRoute path="/flujo-de-caja-categoria-tipo-documento" component={CategoryDocumentType} exact={true}/>
			<PrivateRoute path="/flujo-de-caja-recursos" component={Resources} exact={true}/>

			{/* Indicadores logisticos V2 */}
			<PrivateRoute path="/indicadores-logisticos-gastos" component={BillsPage} exact={true}/>
			<PrivateRoute path="/indicadores-logisticos-partida-de-control" component={LiPcView} exact={true}/>
			<PrivateRoute path="/indicadores-logisticos-partida-de-control-general" component={GeneralPC} exact={true}/>


			<PrivateRoute 
				path="/facturas" 
				component={AccountsPayable} 
				exact={true}
			/>
			<PrivateRoute 
				path="/cuentas-x-pagar" 
				component={BillsToPay} 
				exact={true}
			/>
			<PrivateRoute 
				path="/cuentas-x-cobrar" 
				component={AccountsReceivable} 
				exact={true}
			/>
			<PrivateRoute 
				path="/asistencia" 
				component={AttendancesResume} 
				exact={true}
			/>
		  
        </Layout>
      </Switch>
    </Router>
	</MuiPickersUtilsProvider>
  );
}

export default App;
